export default __webpack_public_path__ + "static/media/Premium Offerings.f349271e.jpg";